import { AfterViewInit, Component, OnDestroy, OnInit, SimpleChange, OnChanges, input, linkedSignal, output, viewChild } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelect, MatOption } from '@angular/material/select';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ISimpleListElement } from '../../models/ISimpleListElement';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatSelectSearchComponent } from 'ngx-mat-select-search';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';


// https://www.npmjs.com/package/ngx-mat-select-search

@Component({
    selector: 'lf-select-search',
    templateUrl: './lf-select-search.component.html',
    styleUrls: ['./lf-select-search.component.scss'],
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, MatOption, MatSelectSearchComponent, MatIconButton, MatSuffix, MatIcon, AsyncPipe]
})
export class LfSelectSearchComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  readonly placeholder = input("");
  readonly placeholderLabel = input("search");
  readonly disabled = input<boolean>(undefined);
  readonly showClose = input("true");
  readonly listElements = input<ISimpleListElement[]>([]);
  readonly selectedElementId = input<number>(undefined);
  readonly selected = output<number>();

  // Wybór jest stanem wewnętrznym: startuje od inputu, dalej zmienia go użytkownik.
  protected readonly currentElementId = linkedSignal<number>(() => this.selectedElementId());

  public elementCtrl: UntypedFormControl = new UntypedFormControl();

  public elementFilterCtrl: UntypedFormControl = new UntypedFormControl();

  public filteredListElements: ReplaySubject<ISimpleListElement[]> = new ReplaySubject<ISimpleListElement[]>(1);

  readonly singleSelect = viewChild<MatSelect>('singleSelect');

  protected _onDestroy = new Subject<void>();

  constructor() { }

  ngOnChanges(changes: Record<string, SimpleChange>) {
    if (changes['disabled']) {
      this.disabled() ? this.elementCtrl.disable({emitEvent: false }) : this.elementCtrl.enable({emitEvent: false });
    }
    if (changes.listElements) {
      if (changes.listElements.currentValue !== changes.listElements.previousValue) {
        this.rebuildDataList();
      }
    }
    else
    {
      this.rebuildDataList();
    }
  }

  ngOnInit() {

    this.rebuildDataList();

    this.elementCtrl.valueChanges.subscribe(
      selectedElement => {
        if (selectedElement) {
          this.currentElementId.set(selectedElement.id);
          this.selected.emit(selectedElement.id);
        }
      }
    );

    this.elementFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterElements();
      });
  }

  protected rebuildDataList() {

    const selectedElementId = this.currentElementId();
    if (!(selectedElementId)) {
      this.elementCtrl.setValue({}, { onlySelf: true, emitEvent: false });
    }

    const listElements = this.listElements();
    if (selectedElementId && listElements) {
      for (let i = 0; i < listElements.length; i++) {
        if (listElements[i].id == selectedElementId) {
          this.elementCtrl.setValue(listElements[i]);
        }
      }
    }

    if (this.filteredListElements && listElements) {
      this.filteredListElements.next(listElements.slice());
    }

  }

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  protected setInitialValue() {
    this.filteredListElements
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.singleSelect().compareWith = (a: ISimpleListElement, b: ISimpleListElement) => a && b && a.id === b.id;
      });
  }

  protected filterElements() {
    const listElements = this.listElements();
    if (!listElements) {
      return;
    }

    let search = this.elementFilterCtrl.value;
    if (!search) {
      this.filteredListElements.next(listElements.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredListElements.next(
      listElements.filter(element => element.name.toLowerCase().indexOf(search) > -1)
    );
  }

  public clearSelection(e){
    this.currentElementId.set(null);
    this.selected.emit(null);

    e.stopPropagation()
  }
}
